<div class="purchase-order-container">
  <!-- What people actually come to this page to do: find one order, or see
       which of them are still waiting on something. Both references search this
       list; the four statuses are the more useful cut, so they get the tabs and
       the code gets the field. -->
  @if (allTransactions().length) {
  <div class="order-filters mb-6">
    <div class="order-filters__tabs" role="group">
      <button type="button" class="btn btn-sm"
              [class.btn-primary]="statusFilter() === null"
              [class.btn-light]="statusFilter() !== null"
              data-testid="order-status-all"
              (click)="selectStatus(null)">
        {{ "APP.ALL" | translate }}
        <span class="order-filters__count">{{ allTransactions().length }}</span>
      </button>
      @for (tab of statusTabs(); track tab.id) {
        <button type="button" class="btn btn-sm"
                [class.btn-primary]="statusFilter() === tab.id"
                [class.btn-light]="statusFilter() !== tab.id"
                (click)="selectStatus(tab.id)">
          {{ tab.name }}
          <span class="order-filters__count">{{ tab.count }}</span>
        </button>
      }
    </div>

    <div class="pill-search order-filters__search">
      <div class="pill-search__field">
        <span class="pill-search__icon" aria-hidden="true">
          <app-keenicon name="magnifier" class="fs-3"></app-keenicon>
        </span>
        <input
          type="search"
          class="pill-search__input"
          data-testid="order-search"
          [value]="codeSearch()"
          [attr.aria-label]="'APP.SEARCH_ORDER' | translate"
          [attr.placeholder]="'APP.SEARCH_ORDER' | translate"
          (input)="onCodeSearch($any($event.target).value)"
        />
        @if (codeSearch().trim().length) {
          <button type="button" class="pill-search__clear"
                  [attr.aria-label]="'QUIZ.SEARCH_CLEAR' | translate"
                  (click)="onCodeSearch('')">×</button>
        }
      </div>
    </div>
  </div>
  }

  <!-- Datatable Content -->
  <div class="datatable-container mb-12">
    <app-table-widget data-testid="order-table" [dataSource]="dataSource" [dataColumns]="dataColumns" [isLoading]="tableLoading()"
      (tableChange)="onTableChange($event)" (onRowClick)="onRowClick($event)"></app-table-widget>
  </div>
</div>


<ng-template #trackingNo let-row>
  <div class="d-flex flex-row gap-2 align-items-center">
    <!-- Was the literal string "EV12132133" on every row regardless of data —
         a fabricated tracking number shown to the customer as if it were real.
         Bound to the field, with an em dash when there is nothing to show. -->
    {{ row.tracking_no || "—" }}
  </div>
</ng-template>
<ng-template #trackingAction let-row>
  <div class="d-flex flex-row gap-3 align-items-center" (click)="$event.stopPropagation()">
    <!-- Two icon-only buttons with no accessible name and a muted glyph on a
         pale grey chip: nothing said what they did, and they read as disabled.
         Tonal brand, brand-ink glyph, and a name for a screen reader and a
         tooltip for everyone else. -->
    <button class="btn btn-sm btn-icon btn-light-primary order-action"
            [attr.aria-label]="'APP.ORDER_COPY_TRACKING' | translate"
            [attr.title]="'APP.ORDER_COPY_TRACKING' | translate"
            (click)="copyTrackingNo(row)">
      <app-keenicon name="copy" class="svg svg-icon fs-4"></app-keenicon>
    </button>
    <button class="btn btn-sm btn-icon btn-light-primary order-action"
            [attr.aria-label]="'APP.ORDER_TRACK' | translate"
            [attr.title]="'APP.ORDER_TRACK' | translate"
            (click)="tracking($event);">
      <app-keenicon name="parcel-tracking" class="svg svg-icon fs-2"></app-keenicon>
    </button>
  </div>
</ng-template>